export default [
	{
		path: "/account/password-change",
		name: "PasswordChange",
		meta: {
			requiresAuth: true
		},
		component: () => import("@/views/account/PasswordChange")
	},
	{
		path: "/account/security/phone-validation",
		name: "PhoneValidation",
		meta: {
			requiresAuth: true
		},
		component: () => import("@/views/account/PhoneValidation")
	},
	{
		path: "/account/events/:id",
		name: "PromoteEvent",
		meta: {
			requiresAuth: true
		},
		component: () => import("@/views/account/PromoteEvent")
	},
	{
		path: "/account/:tab?",
		name: "Account",
		meta: {
			requiresAuth: true
		},
		component: () => import("@/views/account/Account")
	},
	{
		path: "/email-validation/:code",
		name: "EmailValidation",
		meta: {
			requiresAuth: true
		},
		component: () => import("@/views/account/EmailValidation")
	}
]
